<script setup>
import NovelStorefrontSection from './NovelStorefrontSection.vue'
import NovelWorldSection from './NovelWorldSection.vue'
import NovelPositionsSection from './NovelPositionsSection.vue'
defineProps({ modelValue: { type: Object, required: true }, issues: { type: Array, default: () => [] }, upload: { type: Function, required: true }, cover_url: { type: String, default: '' }, load_tags: { type: Function, default: null }, disabled: { type: Boolean, default: false } })
const emit = defineEmits(['update:modelValue', 'blocked', 'clear-cover'])
</script>
<template>
  <section
    class="novel-entities"
    data-testid="novel-overview-section"
  >
    <component
      :is="group"
      v-for="group in [NovelStorefrontSection, NovelWorldSection, NovelPositionsSection]"
      :key="group.__name"
      v-bind="group === NovelStorefrontSection ? { load_tags, disabled } : {}"
      :model-value="modelValue"
      :issues="issues"
      :upload="upload"
      :cover_url="cover_url"
      @update:model-value="emit('update:modelValue', $event)"
      @blocked="emit('blocked', $event)"
      @clear-cover="emit('clear-cover')"
    />
  </section>
</template>
